import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  useRedirect,
  useNotify,
} from 'react-admin';
import {
  Grid,
  Box,
  Typography,
  Alert,
} from '@mui/material';

export const WorkflowCreate = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  const transform = (data: any) => {
    // Add default statuses for new workflow
    data.statuses = [
      {
        name: 'Inspection Scheduled',
        color: '#6B7280',
        orderIndex: 0,
        canDelete: false,
        isDefault: true,
      },
      {
        name: 'Treating',
        color: '#10B981',
        orderIndex: 1,
        canDelete: true,
      },
      {
        name: 'Resolved',
        color: '#10B981',
        orderIndex: 2,
        canDelete: false,
      },
    ];
    // Add default categories
    data.categories = [
      {
        name: 'General',
        sortOrder: 0,
      },
    ];
    // Remove color field as it's not needed
    delete data.color;
    return data;
  };

  const onSuccess = (data: any) => {
    notify('Workflow created successfully. You can now add statuses and categories.', { type: 'info' });
    redirect('edit', '/workflows', data.id);
  };

  return (
    <Create 
      title="Create Workflow" 
      transform={transform}
      mutationOptions={{ onSuccess }}
    >
      <SimpleForm>
        <Typography variant="h6" gutterBottom>
          New Workflow
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextInput 
              source="name" 
              label="Workflow Name" 
              fullWidth 
              required 
              helperText="Choose a descriptive name for this workflow"
            />
          </Grid>
          <Grid item xs={12}>
            <TextInput
              source="description"
              label="Description"
              fullWidth
              multiline
              rows={3}
              helperText="Describe what types of tasks this workflow will handle"
            />
          </Grid>
          <Grid item xs={12}>
            <BooleanInput 
              source="isActive" 
              label="Active" 
              defaultValue={true}
              helperText="Active workflows can be assigned to new tasks"
            />
          </Grid>
          <Grid item xs={12}>
            <Alert severity="info">
              After creating the workflow, you'll be able to:
              <ul style={{ marginTop: 8, marginBottom: 0 }}>
                <li>Add and customize workflow statuses</li>
                <li>Define task categories</li>
                <li>Configure the workflow structure</li>
              </ul>
            </Alert>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};